import Vue from "vue";

import {
  IgaButton,
  IgaCard,
  IgaColumn,
  IgaColumns,
  IgaCrudTable,
  IgaEdit,
  IgaGenericElement,
  IgaIcon,
  IgaTab,
  IgaTable,
  IgaTabPanel,
} from "iga-vue-component";

Vue.component("iga-card", IgaCard);
Vue.component("iga-tab", IgaTab);
Vue.component("iga-tab-panel", IgaTabPanel);
Vue.component("iga-columns", IgaColumns);
Vue.component("iga-column", IgaColumn);
Vue.component("iga-table", IgaTable);
Vue.component("iga-generic-element", IgaGenericElement);
Vue.component("iga-button", IgaButton);
Vue.component("iga-crud-table", IgaCrudTable);
Vue.component("iga-edit", IgaEdit);
Vue.component("iga-icon", IgaIcon);
